"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

// $FlowFixMe - useState is a named export of react
var NO_KEEP_VALUE = Symbol('NO_KEEP_VALUE');

var _default = function _default(_ref) {
  var keepValue = _ref.keepValue,
      parcel = _ref.parcel;
  var keepValueReceivedRef = (0, _react.useRef)(NO_KEEP_VALUE);

  if (!keepValue) {
    keepValueReceivedRef.current = NO_KEEP_VALUE;
    return false;
  }

  var changedBySelf = parcel._lastOriginId.startsWith(parcel.id);

  if (changedBySelf) {
    keepValueReceivedRef.current = parcel.value;
    return true;
  }

  var valueIsSameAsLastChangeBySelf = Object.is(parcel.value, keepValueReceivedRef.current);

  if (!valueIsSameAsLastChangeBySelf) {
    keepValueReceivedRef.current = parcel.value;
  }

  return valueIsSameAsLastChangeBySelf;
};

exports.default = _default;